/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {SignalAdminResourceApiBase, SignalAdminResourceModel} from '../common/controller/signal-admin-resource-api';

export interface PrintLineItemModel extends SignalAdminResourceModel {
  [key: string]: any;
}

export interface PrintLineItemLink {
  qrCode?: string;
  qrCodeEps?: string;
  link?: string;
}

@Injectable({providedIn: 'root'})
export class PrintLineItemApiService extends SignalAdminResourceApiBase<PrintLineItemModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'printlineitems');
  }

  getLink(id: string, printAd = true): Observable<PrintLineItemLink> {
    return this.client.request<PrintLineItemLink>({
      method: 'GET',
      url: this.resourceUri(`printlineitems/${encodeURIComponent(id)}/link`),
      params: {printAd}
    });
  }
}
